var IpcSmdPadGeneratorData = require('./ipcSmdPadGeneratorData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var ComponentAttribute = require('./componentAttribute.js');
var IPCRules = require('../ipcRules');

var DualRowPackageData = function(position, angle, init) {
    IpcSmdPadGeneratorData.apply(this, arguments);
};

lib_core.inherit(DualRowPackageData, IpcSmdPadGeneratorData);
lib_core.JsonParser.registerClass(DualRowPackageData, "DualRowPackageData");

module.exports = DualRowPackageData;

/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
DualRowPackageData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];

    //reset component
    self.component.reset();

    //Note: Pad should be calculated in anti-clockwise direction [left, down, right, up] for quad packages and [left and right] for rest of the packages.
    //The order is important to apply proper pad name from the generated namelist. Do not change the order otherwise pad's name would be incorrect.
    self.updateComponentCalculator(self.horizontalLeadToLeadSpanMin(), self.horizontalLeadToLeadSpanMax());

    var i, nRow = self.component.padsPerSide[0],
        hPitch = self.component.C,
        vPitch = self.verticalPinPitch(),
        motif = self.getMotif();

    for(i = 0; i < 2 * nRow; i++) {
        var col = Math.floor(i / nRow);
        var row = i % nRow;
        if (col % 2 == 1) row = nRow - 1 - row; // in odd columns change order from bottom to top

        var pad = motif.clone();
        pad.move(new lib_geometry.Coord((-0.5 + col) * hPitch, ((nRow - 1) / 2 - row) * vPitch));
        pads.push(pad);
    }

    self.updatePads(pads, absolutePositions);

    return pads;
};

/**
 * Calculate silkscreen for selected component. Silkscreen is calculated from body and pads geometry.
 * @param  {array} pads Pads calculated from getPads() function.
 * @return {array} Array of silkscreen data
 */
DualRowPackageData.prototype.getSilkscreen = function(pads) {
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //get body dimesnsions depending on mapping type of silkscreen to body
    var body = this.getBodyForSilkscreen();
    
    ////////////////////
    //   Pin Marker   //
    ////////////////////

    silkscreen.push(this.getPinOneMarker(pads[0], body));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////

    this.populateSilkscreenForBody(body, pads[0], pads[this.component.padsPerSide[0] - 1], silkscreen);

    return silkscreen;
};